import styled, { keyframes } from "styled-components";
import { Progress } from "antd";
import Bulb from "../../../assets/img/icons/import_lightbulb.svg";
import Cross from "../../../assets/img/icons/import_cross.svg";
import b1 from "../../../assets/img/account-bubbles/b1.png";
import b4 from "../../../assets/img/account-bubbles/b4.png";
import b5 from "../../../assets/img/account-bubbles/b5.png";
import b6 from "../../../assets/img/account-bubbles/b6.png";
import b7 from "../../../assets/img/account-bubbles/b7.png";
import b8 from "../../../assets/img/account-bubbles/b8.png";
import b10 from "../../../assets/img/account-bubbles/b10.png";
import { connect } from "react-redux";
import { useEffect, useState } from "react";

const BubbleProgressPopup: React.FC = () => {
  const [percentage, setPercentage] = useState(0);
  const [totalContacts, setTotalContacts] = useState(1000);
  const [currentImported, setCurrentImported] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setCurrentImported(currentImported < totalContacts ? currentImported + 100 : totalContacts);
      setPercentage(percentage + 10);
    }, 500);
  }, [percentage]);

  return (
    <Wrapper>
      <ProgressWrapper>
        <div className="progress-popup">
          <div className="header">
            <span className="icon padding-sm">
              <img src={Bulb} alt="image" />
            </span>
            <span className="title padding-sm">Importing from xiQ Sales App</span>
            <span className="cross padding-sm">
              <img src={Cross} alt="image" />
            </span>
          </div>
          <div className="body padding-lg padding-bottom-lg padding-top-lg">
            <span className="progress-caption">
              <Progress percent={percentage} status="active" showInfo={false} />
              Importing {currentImported} of {totalContacts} contacts & Accounts
            </span>
          </div>
        </div>

        {/* animation object */}
        {/* first row */}
        <div className="animation-row">
          <img
            style={{ position: "relative", opacity: "0.4" }}
            className="floating-animation-1"
            src={b8}
            alt="image"
          />
          <img style={{ position: "relative" }} className="floating-animation-2" src={b4} alt="image" />
          <img
            style={{ position: "relative", opacity: "0.4" }}
            className="floating-animation-3"
            src={b10}
            alt="image"
          />
          <img
            style={{ position: "relative", opacity: "0.4" }}
            className="floating-animation-4"
            src={b5}
            alt="image"
          />
        </div>

        {/* second row */}
        <div className="animation-row">
          <img style={{ position: "relative" }} className="floating-animation-4" src={b10} alt="image" />
          <img style={{ position: "relative" }} className="floating-animation-5" src={b1} alt="image" />
          <img style={{ position: "relative" }} className="floating-animation-6" src={b8} alt="image" />
          <img style={{ position: "relative" }} className="floating-animation-7" src={b7} alt="image" />
        </div>

        {/* third row */}
        <div className="animation-row">
          <img style={{ position: "relative" }} className="floating-animation-8" src={b7} alt="image" />
          <img style={{ position: "relative" }} className="floating-animation-9" src={b7} alt="image" />
          <img style={{ position: "relative" }} className="floating-animation-10" src={b6} alt="image" />
        </div>
        {/* animation object ends here */}
      </ProgressWrapper>
    </Wrapper>
  );
};

export default connect()(BubbleProgressPopup);

const rotate = keyframes`
0% {
  transform: translateY(0px);
  opacity:0;
}
50% {
  opacity:1;
}
100% {
  transform: translateY(-200px);
  opacity:0;
}
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
  padding-top: 40vh;
  height: 100vh;
  .bubble-wrapper {
    position: relative;
    width: 400px;
  }
`;

const ProgressWrapper = styled.div`
  position: relative;
  z-index: 11;
  .animation-row {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    width: 100%;
    top: 20px;

    .floating-animation-1 {
      position: relative;
      animation: ${rotate} 3s ease-in-out infinite;
    }
    .floating-animation-2 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 0.5s infinite;
    }
    .floating-animation-3 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 1s infinite;
    }
    .floating-animation-4 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 1.5s infinite;
    }

    .floating-animation-5 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 2s infinite;
    }

    .floating-animation-6 {
      position: relative;
      animation: ${rotate} 3s ease-in-out infinite;
    }

    .floating-animation-7 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 3s infinite;
    }

    .floating-animation-8 {
      position: relative;
      animation: ${rotate} 4s ease-in-out 4s infinite;
    }
    .floating-animation-9 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 4.5s infinite;
    }
    .floating-animation-10 {
      position: relative;
      animation: ${rotate} 3s ease-in-out 4s infinite;
    }
  }
  .progress-popup {
    background-color: #fff;
    border-radius: 8px;
    border: solid 1px #eee;
    position: relative;
    z-index: 11;
    width: 370px;
  }
  .header {
    display: flex;
    padding: 0.5em;
    background-color: rgba(39, 206, 10, 0.1);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 15px;
        margin-left: 5px;
      }
    }
    .cross {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 15px;
        }
      }
    }
      .title {
        flex-grow: 1;
        font-family: "robotomedium", sans-serif;
        font-size: 18px;
        color: #09a43a;
        padding-left: 0;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 13px;
          padding-left: 10px;
          padding-top: 10px;
        }
      }
    }
    .body {
      background-color: #fff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .progress-caption {
        color: #7e7e7e;
        font-family: "robotomedium", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
      }
    }
  }
`;
